

import React from "react";
import '../Thankyou/Thankyou.css';

const Thankyou = () => {
  const redirectToHome = () => {
    window.location.href = '/'; 
  };
  return (
    <div className="thankyou-container">
      <h1 className="thankyou-heading">Thank you</h1>
      <p className="thankyou-text">
        Your enquiry has been received and one of our staff will provide you with prices very shortly.
      </p>
      <div className="thankyou-image-container">
        <img src="/thankyou.jpg" alt="Thank You" className="thankyou-image" />
      </div>
      <p className="thankyou-call">
        <strong>Alternatively, if you’d like to talk to one of us right away, just give us a call on</strong> 
        <a href="tel:02039449931" className="thankyou-phone"> 02039449931</a>
      </p>
      {/*-
      <p className="thankyou-footer">
        We may occasionally email you Special Offers and Sale Fares. If you would prefer not to receive these, please click 
        <a href="#" className="thankyou-link"> here.</a>
      </p>
      -*/}
     
      <div className="backBtn">
              <button onClick={redirectToHome} className="button-422">
                Back to Home
              </button>
    </div>
   
    </div>
  );
};

export default Thankyou;
